import React from 'react';
import classnames from 'classnames';

import Input from '@components/Input';

import { getTotalPaymentAmount, getTransactionFee } from '@utils/PaymentUtil';

import './style.scss';

export interface IPaymentPortalPaymentDetails {
  config: IPaymentPortalConfig;
  paymentAmount: number;
  paymentAmountStr: string;
  paymentAmountError: IFieldValidation;
  handleChange?: (e: any) => void;
}

const PaymentPortalPaymentDetails: React.FC<IPaymentPortalPaymentDetails> = ({
  config,
  paymentAmount,
  paymentAmountStr,
  paymentAmountError,
  handleChange,
}) => (
  <div className="credit-card-details-container">
    <div className="credit-card-payment-amount-container">
      <header className="credit-card-payment-amount">
        <div className="label">Credit Card Payment Amount</div>
        <Input
          field={{
            label: '',
            value: paymentAmountStr,
            isRequired: false,
            type: CustomFieldType.TEXT,
          }}
          name="paymentAmount"
          className={classnames('input-with-currency')}
          placeholder={
            config && config.minimumPaymentAmount ? `Minimum Payment Amount is $${config.minimumPaymentAmount}` : ''
          }
          onChange={handleChange}
          width={6}
        />
      </header>
    </div>
    <div className="credit-card-payment-details">
      {config && config.includeTransactionFee && (
        <header className="payment-portal-transaction-fee-details">
          <div className="label">
            Transaction Fee
            {config.transactionFeeType === TransactionFeeType.PERCENTAGE_TRANSACTION_FEE
              ? `( ${config.transactionFeeValue}% )`
              : ''}
          </div>
          <div className="amount">{getTransactionFee(config, paymentAmount)}</div>
        </header>
      )}
      <header className="payment-portal-total-payment-details">
        <div className="label">Total Amount Charged To Credit Card</div>
        <div className="amount">{getTotalPaymentAmount(config, paymentAmount)}</div>
      </header>
      {config && config.includeTransactionFee && (
        <label className="payment-portal-helper-text">
          *When paying with a credit card you will be charged a{' '}
          {config.transactionFeeType === TransactionFeeType.PERCENTAGE_TRANSACTION_FEE
            ? `${config.transactionFeeValue}% `
            : `$${config.transactionFeeValue} `}
          non-refundable convenience fee.
        </label>
      )}
    </div>
  </div>
);

export default PaymentPortalPaymentDetails;
